// Generated by scripts/gen-standard-page-translations.mjs. Do not edit.
import type { CoreLanguageType } from 'shared/src/types/languages.type';
import type { OfferLabelsTranslation } from '../offer-labels-content';
import { offerLabels as lang_bn } from './bn/offer-labels';
import { offerLabels as lang_ca } from './ca/offer-labels';
import { offerLabels as lang_cy } from './cy/offer-labels';
import { offerLabels as lang_eu } from './eu/offer-labels';
import { offerLabels as lang_ga } from './ga/offer-labels';
import { offerLabels as lang_gd } from './gd/offer-labels';
import { offerLabels as lang_gl } from './gl/offer-labels';
import { offerLabels as lang_hi } from './hi/offer-labels';
import { offerLabels as lang_it } from './it/offer-labels';
import { offerLabels as lang_ja } from './ja/offer-labels';
import { offerLabels as lang_mi } from './mi/offer-labels';
import { offerLabels as lang_mr } from './mr/offer-labels';
import { offerLabels as lang_nl } from './nl/offer-labels';
import { offerLabels as lang_pl } from './pl/offer-labels';
import { offerLabels as lang_pt_BR } from './pt-BR/offer-labels';
import { offerLabels as lang_pt_PT } from './pt-PT/offer-labels';
import { offerLabels as lang_rm } from './rm/offer-labels';
import { offerLabels as lang_sv } from './sv/offer-labels';
import { offerLabels as lang_ta } from './ta/offer-labels';
import { offerLabels as lang_te } from './te/offer-labels';

export const offerLabelsTranslations: Partial<Record<CoreLanguageType, OfferLabelsTranslation>> = {
  'bn': lang_bn,
  'ca': lang_ca,
  'cy': lang_cy,
  'eu': lang_eu,
  'ga': lang_ga,
  'gd': lang_gd,
  'gl': lang_gl,
  'hi': lang_hi,
  'it': lang_it,
  'ja': lang_ja,
  'mi': lang_mi,
  'mr': lang_mr,
  'nl': lang_nl,
  'pl': lang_pl,
  'pt-BR': lang_pt_BR,
  'pt-PT': lang_pt_PT,
  'rm': lang_rm,
  'sv': lang_sv,
  'ta': lang_ta,
  'te': lang_te,
};
